import toast from "react-hot-toast";
import {
  FETCH_GROWTH_PLAN_COMPANY_DETAILS_REQUEST,
  FETCH_GROWTH_PLAN_COMPANY_DETAILS_SUCCESS,
  FETCH_GROWTH_PLAN_COMPANY_DETAILS_FAILURE,
  SUBMIT_GOALS_DETAILS_REQUEST,
  SUBMIT_GOALS_DETAILS_SUCCESS,
  SUBMIT_GOALS_DETAILS_FAILURE,
  CONFIRM_GOALS_DETAILS_REQUEST,
  CONFIRM_GOALS_DETAILS_SUCCESS,
  CONFIRM_GOALS_DETAILS_FAILURE,
  RESET_GROWTH_PLAN_ASSESSMENT,
  FETCH_GROWTH_PLAN_ASSESSMENT_LIST_REQUEST,
  FETCH_GROWTH_PLAN_ASSESSMENT_LIST_SUCCESS,
  FETCH_GROWTH_PLAN_ASSESSMENT_LIST_FAILURE,
  MARK_AND_UPDATE_GROWTH_PLAN_ASSESSMENT,
  FETCH_GOALS_LIST
} from "./types";
import { getGrowthPlanAssessmentListApi } from "services/growPlanAssessmentService";
import { postMarkAsVerifiedGrowthPlanAssessmentApi } from "services/growPlanAssessmentService";
import { getGrowthPlanCompanyDetailsApi } from "services/growPlanAssessmentService";
import { postSubmitGrowthPlanAssessmentApi } from "services/growPlanAssessmentService";
import { postConfirmGrowthPlanAssessmentApi } from "services/growPlanAssessmentService";
import { getGoalsListApi } from "services/growPlanAssessmentService";
import { getDownloadGrowthPlanReportApi } from "services/growPlanAssessmentService";

export const fetchGrowthPlanCompanyDetailsRequest = () => {
  return {
    type: FETCH_GROWTH_PLAN_COMPANY_DETAILS_REQUEST
  };
};

export const fetchGrowthPlanCompanyDetailsSuccess = (data) => {
  return {
    type: FETCH_GROWTH_PLAN_COMPANY_DETAILS_SUCCESS,
    payload: data
  };
};

export const fetchGrowthPlanCompanyDetailsFailure = (error) => {
  return {
    type: FETCH_GROWTH_PLAN_COMPANY_DETAILS_FAILURE,
    payload: error
  };
};

export const fetchCompanyDetailsThunkAction = (onSuccess, onError) => {
  return async (dispatch) => {
    try {
      dispatch(fetchGrowthPlanCompanyDetailsRequest());
      const response = await getGrowthPlanCompanyDetailsApi();

      if (response?.status !== 200) {
        throw new Error(response?.data?.message);
      }

      dispatch(fetchGrowthPlanCompanyDetailsSuccess(response.data.data));
      onSuccess();
    } catch (error) {
      dispatch(
        fetchGrowthPlanCompanyDetailsFailure(error?.response?.data?.message || error?.message)
      );
      onError(error?.response?.data?.message || error?.message);
    }
  };
};

export const submitGoalsDetailsRequest = () => {
  return {
    type: SUBMIT_GOALS_DETAILS_REQUEST
  };
};

export const submitGoalsDetailsSuccess = (data) => {
  return {
    type: SUBMIT_GOALS_DETAILS_SUCCESS,
    payload: data
  };
};

export const submitGoalsDetailsFailure = (error) => {
  return {
    type: SUBMIT_GOALS_DETAILS_FAILURE,
    payload: error
  };
};

export const submitGoalsDetailsThunkAction = (postData, onSuccess = () => {}) => {
  return async (dispatch) => {
    try {
      dispatch(submitGoalsDetailsRequest());
      const response = await postSubmitGrowthPlanAssessmentApi(postData);

      if (response?.status !== 200) {
        throw new Error(response?.data?.message);
      }

      dispatch(submitGoalsDetailsSuccess(response.data.data));
      onSuccess();
    } catch (error) {
      dispatch(submitGoalsDetailsFailure(error?.response?.data?.message || error?.message));
      console.log(error?.response?.data?.message || error?.message);
    }
  };
};

export const confirmGoalsDetailsRequest = () => {
  return {
    type: CONFIRM_GOALS_DETAILS_REQUEST
  };
};

export const confirmGoalsDetailsSuccess = () => {
  return {
    type: CONFIRM_GOALS_DETAILS_SUCCESS
  };
};

export const confirmGoalsDetailsFailure = (error) => {
  return {
    type: CONFIRM_GOALS_DETAILS_FAILURE,
    payload: error
  };
};

export const confirmGoalsDetailsThunkAction = (id, postData, onSuccess = () => {}) => {
  return async (dispatch) => {
    try {
      dispatch(confirmGoalsDetailsRequest());
      const response = await postConfirmGrowthPlanAssessmentApi(id, postData);

      if (response?.status !== 200) {
        throw new Error(response?.data?.message);
      }

      dispatch(confirmGoalsDetailsSuccess());
      onSuccess();
    } catch (error) {
      dispatch(confirmGoalsDetailsFailure(error?.response?.data?.message || error?.message));
      console.log(error?.response?.data?.message || error?.message);
    }
  };
};

export const resetGrowthPlanAssessment = () => {
  return {
    type: RESET_GROWTH_PLAN_ASSESSMENT
  };
};

export const fetchGrowthPlanAssessmentListRequest = () => {
  return {
    type: FETCH_GROWTH_PLAN_ASSESSMENT_LIST_REQUEST
  };
};

export const fetchGrowthPlanAssessmentListSuccess = (assessmentlist, totalPage) => {
  return {
    type: FETCH_GROWTH_PLAN_ASSESSMENT_LIST_SUCCESS,
    payload: { assessmentlist, totalPage }
  };
};

export const fetchGrowthPlanAssessmentListFailure = (error) => {
  return {
    type: FETCH_GROWTH_PLAN_ASSESSMENT_LIST_FAILURE,
    payload: error
  };
};

export const fetchGrowthPlanAssessmentListThunkAction = (params, onSuccess, onError) => {
  return async (dispatch) => {
    try {
      dispatch(fetchGrowthPlanAssessmentListRequest());
      const { data } = await getGrowthPlanAssessmentListApi(params);

      if (data.statusCode !== 200) {
        throw new Error(data.message);
      }

      dispatch(
        fetchGrowthPlanAssessmentListSuccess(
          data.data.data,
          data.data.meta.total_records / params.limit
        )
      );
      onSuccess();
    } catch (error) {
      dispatch(fetchGrowthPlanAssessmentListFailure(error));
      onError(error?.response?.data?.message || error?.message);
    }
  };
};

export const markAndUpdateGrowthPlanAssessment = (id) => {
  return {
    type: MARK_AND_UPDATE_GROWTH_PLAN_ASSESSMENT,
    payload: id
  };
};

export const markAsVerifiedGrowthPlanAssessmentThunkAction = (id) => {
  return async (dispatch) => {
    try {
      const response = postMarkAsVerifiedGrowthPlanAssessmentApi(id);

      toast.promise(response, {
        loading: "action in progress...",
        success: "Growth plan marked as verified successfully!",
        error: (error) => {
          return error?.response?.data?.message || error?.message || "Something went wrong!";
        }
      });

      const { data } = await response;

      if (data.statusCode !== 200) {
        throw new Error(data.message);
      }

      dispatch(markAndUpdateGrowthPlanAssessment(id));
    } catch (error) {
      console.log(error?.response?.data?.message || error?.message);
    }
  };
};

export const fetchGoalsListThunkAction = () => {
  return async (dispatch) => {
    try {
      const response = getGoalsListApi();

      const { data } = await response;

      if (data.statusCode !== 200) {
        throw new Error(data.message);
      }

      dispatch({
        type: FETCH_GOALS_LIST,
        payload: data.data
      });
    } catch (error) {
      console.log(error?.response?.data?.message || error?.message);
    }
  };
};

export const fetchDownloadGrowthPlanReportThunkAction = (id, onSuccess, onError) => {
  return async (dispatch) => {
    try {
      const response = getDownloadGrowthPlanReportApi(id);

      const { data } = await response;

      // if (data.statusCode !== 200) {
      //   throw new Error(data.message);
      // }

      // // Create a blob from the response
      const blob = new Blob([data], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);
      window.open(url, "_blank");

      // // Create a temporary anchor element and trigger download
      // const link = document.createElement("a");
      // link.href = url;
      // link.target = "_blank";
      // link.setAttribute("open", `growth_report_${id}.pdf`); // change filename
      // // new tab download

      // document.body.appendChild(link);
      // link.click();

      // // Cleanup
      // link.remove();
      // window.URL.revokeObjectURL(url);
      onSuccess();
    } catch (error) {
      onError();
      console.log(error?.response?.data?.message || error?.message);
    }
  };
};
